

import { useNavigate } from "react-router-dom"
import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"
import Constant from "utils/Constants"
import LocalStorageUtils from "utils/LocalStorage"
import SessionStorageUtils from "utils/SessionStorage"
import { dismissToast, errorToast, loadingToastId } from "utils/Toast"
import { getLoginSession } from "services/auth/loginResponse"



const REPO_URL = {
    login: '/api/v1/auth/login',
    register: '/api/v1/auth/register',
    oidcGoogleStart: '/api/v1/auth/oidc/google/start',
    oidcExchange: '/api/v1/auth/oidc/exchange',
    changePassword: '/auth/change-password',
    refreshToken: '/User/refresh-login',
    revokeCookies: '/User/revoke-cookies',
    logout: '/User/logout',

}

const persistSession = (response) => {
    const session = getLoginSession(response)

    if (!session) return null

    LocalStorageUtils.jwtToken.set(session.token)
    SessionStorageUtils.currentJwtToken.set(session.token)
    sessionStorage.setItem("orgId", session.user?.orgId || "")
    sessionStorage.setItem("wcId", session.user?.wcId || "")
    LocalStorageUtils.userInfo.set(session.user)

    return session
}

const useAuthRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading, true)

    const navigate = useNavigate()

   
    const login = async (email, password) => {
        const payload = { email, password }

        const res = await executeApi(
            REPO_URL.login,
            BASE_API_CONSTANT.METHOD.POST,
            payload,
            { isUnauthenticated: true } // 🔴 login harus unauthenticated
        )

        persistSession(res)

        return res
    }

    const register = async ({ email, fullName }) => {
        return await executeApi(
            REPO_URL.register,
            BASE_API_CONSTANT.METHOD.POST,
            { email, fullName, jobTitle: null, phoneNumber: null },
            { isUnauthenticated: true }
        )
    }

    const startGoogleOidc = async () => {
        return await executeApi(
            REPO_URL.oidcGoogleStart,
            BASE_API_CONSTANT.METHOD.POST,
            { redirectTarget: 'default' },
            { isUnauthenticated: true }
        )
    }

    const exchangeOidcHandoff = async (handoff) => {
        const res = await executeApi(
            REPO_URL.oidcExchange,
            BASE_API_CONSTANT.METHOD.POST,
            { handoff },
            { isUnauthenticated: true }
        )

        persistSession(res)
        return res
    }


    // const login = async (email, password) => {
    //     const payload = { email, password }

    //     const raw = await executeApi(
    //         REPO_URL.login,
    //         BASE_API_CONSTANT.METHOD.POST,
    //         payload,
    //         { isUnauthenticated: false }
    //     )

    //     const body = normalizeBody(raw)

    //     // body format: { status, detail, data: { token, orgId, wcId, ... } }
    //     if (body?.status === 200 && String(body?.detail || "").toUpperCase() === "OK") {
    //         const user = body?.data ?? {}
    //         const token = user?.token || ""

    //         if (token) {
    //             // token
    //             LocalStorageUtils.jwtToken.set(token)
    //             SessionStorageUtils.currentJwtToken.set(token)

    //             // ✅ simpan context dashboard
    //             SessionStorageUtils.wcId?.set
    //                 ? SessionStorageUtils.wcId.set(user?.wcId || "")
    //                 : sessionStorage.setItem("wcId", user?.wcId || "")

    //             SessionStorageUtils.orgId?.set
    //                 ? SessionStorageUtils.orgId.set(user?.orgId || "")
    //                 : sessionStorage.setItem("orgId", user?.orgId || "")

    //             // ✅ simpan userInfo lengkap (untuk kebutuhan UI)
    //             LocalStorageUtils.userInfo.set(user)

    //             return body
    //         }
    //     }

    //     return body
    // }

    // const login = async (email, password) => {
    //     const payload = {
    //         email,
    //         password
    //     }

    //     let response = await executeApi(REPO_URL.login, BASE_API_CONSTANT.METHOD.POST, payload, { isUnauthenticated: false })

    //     if (response?.status === 200 && response?.data?.token) {

    //         const token = response?.data?.token;
    //         const userInfo = response?.data; // semua info user
    //         LocalStorageUtils.jwtToken.set(token)
    //         SessionStorageUtils.currentJwtToken.set(token)
    //         LocalStorageUtils.userInfo.set(userInfo); // <- Tambahkan ini
    //         return response
    //     }

    //     return response
    // }

    const refreshToken = async () => {
        return await executeApi(REPO_URL.refreshToken, BASE_API_CONSTANT.METHOD.POST)
    }

    const logout = async () => {
        loadingToastId(Constant.message.onLogout, 1)

        try {
            LocalStorageUtils.jwtToken.clear()
            LocalStorageUtils.userInfo.clear()
            SessionStorageUtils.all.clear()
        } finally {
            dismissToast(1)
            navigate('/', { replace: true })
        }
    }

    const revokeCookies = async () => {
        // loadingToastId(Constant.message.onLogout, 1)
        let response = await executeApi(REPO_URL.revokeCookies, BASE_API_CONSTANT.METHOD.POST, data, null, false)
        // dismissToast(1)
        if (response?.isValid && response.statusCode === 200) {
            // successToast(Constant.message.logoutSuccess)
            LocalStorageUtils.all.clear()
            navigate('/', { replace: true })
            return response
        } else {
            errorToast(response?.message)
            LocalStorageUtils.all.clear()
            navigate('/', { replace: true })
            return response
        }
    }

    const changePassword = async (payload) => {
        return await executeApi(REPO_URL.changePassword, BASE_API_CONSTANT.METHOD.POST, payload)
    }



    return {
        isLoading,
        data,
        error,
        login,
        register,
        startGoogleOidc,
        exchangeOidcHandoff,
        refreshToken,
        logout,
        revokeCookies,
        changePassword
    }
}

export default useAuthRepo
